export default "__VITE_ASSET__BqIHLlmu__"